// 设置 rem 函数
function setRem() {
    // 1920 默认大小16px; 1920px = 120rem ;每个元素px基础上/16
    const screenWidth = 1920
    const scale = screenWidth / 200
    const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
    const htmlDom = document.getElementsByTagName('html')[0]
    // 得到html的Dom元素
    // 设置根元素字体大小
    if (document.documentElement.clientWidth > 1920) {
        htmlDom.style.fontSize = '192px'
    } else {
        htmlDom.style.fontSize = htmlWidth / scale + 'px'
    }
  }
  // 初始化
  export default setRem